import { FETCH_ERROR, CLEAR_ERROR } from "../actions/types";

export const errorReducer = (state = null, action) => {
  switch (action.type) {
    case FETCH_ERROR:
      return action.payload;
    case CLEAR_ERROR:
      return null;
    default:
      return state;
  }
};
